import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios';

// 协议
import agreement from './pages/agreement.vue'; // 注册协议
import privacy from './pages/privacy.vue'; //隐私政策
import orderanswer from './pages/orderanswer.vue'; // 预订须知
import securityServices from './pages/securityServices.vue'; // 基本保障说明
import agreementOrder from './pages/agreementOrder.vue'; // 订单须知
import ruleAlert from './pages/ruleAlert.vue'; // 积分规则
import orderNotes from './pages/orderNotes.vue'; // 预定条款
import safeDriving from './pages/safeDriving.vue'; // 驾无忧保障
import selectedModels from './pages/selectedModels.vue'; // 预订页精选车型
import orderDeposit from './pages/orderDeposit.vue'; // 订单押金说明
import doubleDeposit from './pages/doubleDeposit.vue'; // 首页押金双免

import vehicleActivity from './pages/vehicleActivity.vue'; // 活动模板页
import vehicleActivityInfo from './pages/vehicleActivityInfo.vue'; // 活动模板详情页
import activity from './pages/activity.vue';  //领券中心
import newActivity from './pages/newActivity.vue';//改版领券中心
import cooperation from './pages/cooperation.vue'; // 商务合作
import becomeOwner from './pages/becomeOwner.vue'; // 成为车主
import invitetenants from './pages/Invitetenants.vue'; //邀请租客
import jointenants from './pages/Jointenants.vue'; // 邀请好友活动
import newcoupon from './pages/newcoupon.vue'; // 新用户优惠券
import couponlist from './pages/couponlist.vue';  //优惠券列表
import shareCarCityList from './pages/shareCarCityList.vue';  //城市列表
import selectAddress from './pages/selectAddress.vue';  //选择地址
import addcar from './pages/addcar.vue';  //添加车辆
import renewal from "./pages/renewalNotice"; //续租须知
import agreementRelet from "@/pages/agreementRelet"; //续租协议
import huabeiAgreement from "@/pages/huabeiAgreement";// 话呗分期说明
import agreement_carOwner from "@/pages/agreement_carOwner";// 车主端隐私政策
import assistanceDraw from "@/pages/assistanceDraw"; // 春节活动

// banner 跳转地址
import wrnt from '@/pages/bannerInfo/wrnt';  // 双免介绍页
import goldenFall from '@/pages/bannerInfo/goldenFall';  // 金秋活动券
import newVoucher from '@/pages/bannerInfo/newVoucher';  // 新人优惠活动券
import topTips from '@/pages/bannerInfo/topTips';  // 首页活动详情
import marchAct from '@/pages/bannerInfo/marchAct';  // 疫情活动
import weeklyAct from '@/pages/bannerInfo/weeklyAct';  // 包周活动
import luckDraw from '@/pages/bannerInfo/luckDraw';  // 春节优惠券+抽奖活动
import tombSweepingDay from '@//pages/bannerInfo/tombSweepingDay'; // 2020清明节活动
import reWork from '@//pages/bannerInfo/reWork'; // 复工重启ing 自驾更安全
import assistWuhan from '@/pages/bannerInfo/assistWuhan'; // 爆款车型 天天9元
import laborDay from '@/pages/bannerInfo/laborDay'; // 五一活动
import reWuhan from '@/pages/bannerInfo/reWuhan'; // 好久不见 武汉大方欢迎你
import welWuhan from '@/pages/bannerInfo/welWuhan'; //
import dragon from "@/pages/bannerInfo/dragon"; //49元起 端午出游
import solicitation from "@/pages/bannerInfo/solicitation";
import summer from "@/pages/bannerInfo/summer"; //避暑自驾游
import national from "@/pages/bannerInfo/national";//国庆遇中秋
import DuanWu from "@/pages/bannerInfo/DuanWu"; //端午节活动
import roadTrip from "@/pages/bannerInfo/roadTrip" // 盛夏自驾
import northwestDriving from '@/pages/bannerInfo/northwestDriving';
import summerPomotion from '@/pages/bannerInfo/summerPomotion';
import visitHubei from '@/pages/bannerInfo/visitHubei';
import autumn from "@/pages/bannerInfo/autumn";
import doubleEleven from "@/pages/bannerInfo/doubleEleven"; // 双十一活动
import workDay from "@/pages/bannerInfo/workDay";
import winter from "@/pages/bannerInfo/winter";
import newYear from "@/pages/bannerInfo/newYear";
import springWarm from "@/pages/bannerInfo/springWarm";
import tenYears from "@/pages/bannerInfo/tenYears";
import exclusiveAPP from "@/pages/bannerInfo/exclusiveAPP";
import Qingming from "@/pages/bannerInfo/Qingming";
import lowPriceCar from "@/pages/bannerInfo/lowPriceCar"
import mayHoliday from "@/pages/bannerInfo/mayHoliday"
import newMenber from "@/pages/bannerInfo/newMenber"
import earlySummer from "@/pages/bannerInfo/earlySummer"
import loverDay from "@/pages/bannerInfo/loverDay"
import evaluate from "@/pages/bannerInfo/evaluate"
import newUser from "@/pages/bannerInfo/newUser"


Vue.use(Router);
const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/newUser',
      name: 'newUser',
      component: newUser,
      meta: {
        title: '新会员首日0元起租'
      }
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      component: evaluate,
      meta: {
        title: '评价有礼'
      }
    },
    {
      path: '/roadTrip',
      name: 'roadTrip',
      component: roadTrip,
      meta: {
        title: '盛夏自驾 轻松一夏'
      }
    },
    {
      path: '/DuanWu',
      name: 'DuanWu',
      component: DuanWu,
      meta: {
        title: '端午自驾 粽行天下'
      }
    },
    {
      path: '/loverDay',
      name: 'loverDay',
      component: loverDay,
      meta: {
        title: '约惠520 为爱出发'
      }
    },
    {
      path: '/wrnt',
      name: 'wrnt',
      component: wrnt,
      meta: {
        title: '押金双免介绍'
      }
    },
    {
      path: '/Qingming',
      name: 'Qingming',
      component: Qingming,
      meta: {
        title: '清明租车去踏青'
      }
    },
    {
      path: '/earlySummer',
      name: 'earlySummer',
      component: earlySummer,
      meta: {
        title: '租辆好车 初夏自驾游'
      }
    },
    {
      path: '/mayHoliday',
      name: 'mayHoliday',
      component: mayHoliday,
      meta: {
        title: '五一自驾游，连租更优惠'
      }
    },
    {
      path: '/newMenber',
      name: 'newMenber',
      component: newMenber,
      meta: {
        title: '新会员首日0元起租'
      }
    },
    {
      path: '/exclusiveAPP',
      name: 'exclusiveAPP',
      component: exclusiveAPP,
      meta: {
        title: 'APP专属专属福利'
      }
    },
    {
      path: '/doubleEleven',
      name: 'doubleEleven',
      component: doubleEleven,
      meta: {
        title: '双十一 自驾狂欢节'
      }
    },
    {
      path: '/tenYears',
      name: 'tenYears',
      component: tenYears,
      meta: {
        title: '大方租车10周年'
      }
    },
    {
      path: '/agreementCarOwner',
      name: 'agreement_carOwner',
      component: agreement_carOwner,
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/springWarm',
      name: 'springWarm',
      component: springWarm,
      meta: {
        title: '春暖花开 出行正当时'
      }
    },
    {
      path: '/workDay',
      name: 'workDay',
      component: workDay,
      meta: {
        title: '工作日用车，1周只要100元'
      }
    },
     {
      path: '/newYear',
      name: 'newYear',
      component: newYear,
      meta: {
        title: '元旦租车，折扣火力全开'
      }
    },
    {
      path: '/lowPriceCar',
      name: 'lowPriceCar',
      component: lowPriceCar,
      meta: {
        title: '低价租好车'
      }
    },
    {
      path: '/winter',
      name: 'winter',
      component: winter,
      meta: {
        title: '邂逅暖冬，温暖出行'
      }
    },
    {
      path: '/solicitation',
      name: 'solicitation',
      component: solicitation,
      meta: {
        title: '大方有奖征集'
      }
    },
    {
      path: '/national',
      name: 'national',
      component: national,
      meta: {
        title: '中秋遇国庆，低价租好车'
      }
    },
    {
      path: '/summerPomotion',
      name: 'summerPomotion',
      component: summerPomotion,
      meta: {
        title: '大方租车 巅峰逆袭'
      }
    },
    {
      path: '/northwestDriving',
      name: 'northwestDriving',
      component: northwestDriving,
      meta: {
        title: '自驾大西北 探秘夏季最美仙境'
      }
    },
    {
      path: '/laborDay',
      name: 'laborDay',
      component: laborDay,
      meta: {
        title: '五一自驾 低价租好车'
      }
    },
    {
      path: '/visitHubei',
      name: 'visitHubei',
      component: visitHubei,
      meta: {
        title: '大方浪个够 惠游湖北'
      }
    },
    {
      path: '/assistWuhan',
      name: 'assistWuhan',
      component: assistWuhan,
      meta: {
        title: '爆款车型 天天9元'
      }
    },
    {
      path: '/reWuhan',
      name: 'reWuhan',
      component: reWuhan,
      meta: {
        title: '好久不见 武汉大方欢迎你'
      }
    },
    {
      path: '/welWuhan',
      name: 'welWuhan',
      component: welWuhan,
      meta: {
        title: '大方欢迎武汉人'
      }
    },
    {
      path: '/dragon',
      name: 'dragon',
      component: dragon,
      meta: {
        title: '奥利给！今年端午 49元租车出游'
      }
    },
    {
      path: '/summer',
      name: 'summer',
      component: summer,
      meta: {
        title: '避暑自驾游'
      }
    },
    {
      path: '/reWork',
      name: 'reWork',
      component: reWork,
      meta: {
        title: '复工重启ing 自驾更安全'
      }
    },
    {
      path: '/tombSweepingDay',
      name: 'tombSweepingDay',
      component: tombSweepingDay,
      meta: {
        title: '清明踏青 租车享特惠'
      }
    },
    {
      path: '/goldenFall',
      name: 'goldenFall',
      component: goldenFall,
      meta: {
        title: '金秋活动券'
      }
    },
    {
      path: '/topTips',
      name: 'topTips',
      component: topTips,
      meta: {
        title: '品质严选'
      }
    },
    {
      path: '/marchAct',
      name: 'marchAct',
      component: marchAct,
      meta: {
        title: '疫情当前 自驾更安全'
      }
    },
    {
      path: '/weeklyAct',
      name: 'weeklyAct',
      component: weeklyAct,
      meta: {
        title: '包周活动'
      }
    },
    {
      path: '/newVoucher',
      name: 'newVoucher',
      component: newVoucher,
      meta: {
        title: '新人优惠活动券'
      }
    },
    {
      path: '/luckDraw',
      name: 'luckDraw',
      component: luckDraw,
      meta: {
        title: '春节自驾租大方'
      }
    },
    {
      path: '/autumn',
      name: 'autumn',
      component: autumn,
      meta: {
        title: '秋日宜自驾'
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta: {
        title: '大方租车用户协议'
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy,
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/securityServices',
      name: 'securityServices',
      component: securityServices,
      meta: {
        title: 'securityServices'
      }
    },
    {
      path: '/ruleAlert',
      name: 'ruleAlert',
      component: ruleAlert,
      meta: {
        title: 'ruleAlert'
      }
    },
    {
      path: '/safeDriving',
      name: 'safeDriving',
      component: safeDriving,
      meta: {
        title: '驾无忧保障说明'
      }
    },
    {
      path: '/selectedModels',
      name: 'selectedModels',
      component: selectedModels,
      meta: {
        title: '精选车型组说明'
      }
    },
    {
      path: '/orderDeposit',
      name: 'orderDeposit',
      component: orderDeposit,
      meta: {
        title: '订单押金说明'
      }
    },
    {
      path: '/doubleDeposit',
      name: 'doubleDeposit',
      component: doubleDeposit,
      meta: {
        title: '首页押金双免'
      }
    },
    {
      path: '/agreementOrder',
      name: 'agreementOrder',
      component: agreementOrder,
      meta: {
        title: 'agreementOrder'
      }
    },
    {
      path: '/orderNotes',
      name: 'orderNotes',
      component: orderNotes,
       meta: {
        title: 'orderNotes'
      }
    },
    {
      path: '/orderanswer',
      name: 'orderanswer',
      component: orderanswer,
       meta: {
        title: 'orderanswer'
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity,
       meta: {
        title: '领券中心'
      }
    },
    {
      path: '/newActivity',
      name: 'newActivity',
      component: newActivity,
       meta: {
        title: '领券中心'
      }
    },
    {
      path: '/vehicleActivity',
      name: 'vehicleActivity',
      component: vehicleActivity,
      meta: {
        title: '活动'
      }
    },
    {
      path: '/vehicleActivityInfo',
      name: 'vehicleActivityInfo',
      component: vehicleActivityInfo,
      meta: {
        title: '', // 车辆置顶活动详情
      }
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation,
      meta: {
        title: '我要合作',
      }
    },
    {
      path: '/becomeOwner',
      name: 'becomeOwner',
      component: becomeOwner,
      meta: {
        title: '', // 成为车主
      }
    },
    {
      path: '/invitetenants',
      name: 'invitetenants',
      component: invitetenants,
      meta: {
        title: '邀请租客奖励规则',
      }
    },
    {
      path: '/jointenants',
      name: 'jointenants',
      component: jointenants,
      meta: {
        title: '邀请好友活动'
      }
    },
     {
      path: '/newcoupon',
      name: 'newcoupon',
      component: newcoupon,
      meta: {
        title: '新人优惠券',  //新人券
      }
    },
    {
      path: '/couponlist',
      name: 'couponlist',
      component: couponlist,
      meta: {
        title: '优惠券列表',  //优惠券列表
      }
    },
    {
      path: '/shareCarCityList',
      name: 'shareCarCityList',
      component: shareCarCityList,
      meta: {
        title: '城市列表',  //城市列表
      }
    },
    {
      path: '/selectAddress',
      name: 'selectAddress',
      component: selectAddress,
      meta: {
        title: '选择地址',  //选择地址
      }
    },
    {
      path: '/assistanceDraw',
      name: 'assistanceDraw',
      component: assistanceDraw,
      meta: {
        title: '自由自驾过大年',  //选择地址
      }
    },
    {
      path: '/addcar',
      name: 'addcar',
      component: addcar,
      meta: {
        title: '添加车辆'
      }
    },
    {
      path: '/renewal',
      name: 'renewal',
      component: renewal,
      meta: {
        title: '续租须知'
      }
    },
    {
      path: '/agreementRelet',
      name: 'agreementRelet',
      component: agreementRelet,
      meta: {
        title: '续租协议'
      }
    },
    {
      path: '/huabeiAgreement',
      name: 'huabeiAgreement',
      component: huabeiAgreement,
      meta: {
        title: '花呗分期'
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (Vue.prototype.source) {
    const CancelToken = axios.CancelToken;
    Vue.prototype.source.cancel && Vue.prototype.source.cancel("取消请求");
    Vue.prototype.source = CancelToken.source();
  }
  Vue.prototype.prevPath = from.fullPath;
  next();
});
router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});
export default router
